module.exports = __webpack_public_path__ + "img/icon_map_jyz.5c89abd7.png";